/* eslint-disable boundaries/element-types */
import { StyledSelectDiv } from 'components/rightDrawer/drawerStates/crudWorkflows/utils/sharedStyles'
import React from 'react'
import { Control, Controller, FieldErrors } from 'react-hook-form'
import { CustomProvider, SelectPicker } from 'rsuite'
import { DropdownOption } from 'types'

import { ImportInspectionSchema } from './importInspectionSchema'

export enum EntryNames {
  Inspection_Slug = 'inspection_slug',
  Component = 'component',
  Job = 'job',
  Unit = 'unit',
  Site = 'site',
  Organization = 'organization',
}

type FormControllerProps = {
  name: EntryNames
  control: Control<ImportInspectionSchema>
  options: DropdownOption[]
  label: string
  testID: string
  onChangeFn?: (value: string) => void
  errors: FieldErrors
  clearDependentFields?: () => void
}

export const FormController = ({
  name,
  control,
  options,
  label,
  testID,
  onChangeFn,
  errors,
  clearDependentFields,
}: FormControllerProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onBlur, onChange, ref, value } }) => (
        <StyledSelectDiv>
          <label>{label}</label>
          <CustomProvider theme='dark'>
            <SelectPicker
              ref={ref}
              data-testid={testID}
              onBlur={onBlur}
              onChange={(selectedValue) => {
                onChange(selectedValue)
                if (onChangeFn && selectedValue) {
                  onChangeFn(selectedValue)
                }
                if (!selectedValue && clearDependentFields) {
                  clearDependentFields()
                }
              }}
              searchable
              value={value}
              data={options}
              aria-invalid={!!errors[name]}
            />
          </CustomProvider>
          {errors[name] && (
            <span role='alert'>{errors[name]?.message?.toString()}</span>
          )}
        </StyledSelectDiv>
      )}
    />
  )
}
